export default __webpack_public_path__ + "static/media/330_dummy2016-ernaehrungsberatung01-mobile-de.d34c44c4.png";